import React, { useState } from 'react';
import ManageModal from 'shared/components/modals/ManageModal';
import Input from 'shared/components/Input';
import Textarea from 'shared/components/Textarea';
import PollImageSelection from './PollImageSelection';
import PollImageBlock from './PollImageBlock';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import { getError } from 'utils/appHelpers';
import { createPoll } from 'app/routes/Dashboard/actions/polls';

const CreatePollModal = ({ onClose, onSuccess }) => {
  const alert = useAlert();
  const { t } = useTranslation();
  const [fetching, setFetching] = useState(false);
  const [currentImageBlock, setCurrentImageBlock] = useState();
  const [form, setForm] = useState({
    title: '',
    firstLikieeId: '',
    secondLikieeId: '',
    firstImage: '',
    secondImage: '',
  });

  const onFormChange = ({ target }) => {
    const { name, value } = target;
    setForm({ ...form, [name]: value });
  };

  const handleProjectModalClose = () => {
    if (onClose) onClose();
  };

  const onFormSubmit = async () => {
    try {
      setFetching(true);
      const poll = await createPoll(form);
      handleProjectModalClose();
      if (onSuccess) onSuccess(poll);
      setFetching(false);
    } catch (err) {
      setFetching(false);
      alert.error(getError(err));
    }
  };

  const onSelectImageBlock = name => {
    setCurrentImageBlock(name);
  };

  const onChooseImages = (pollName, res) => {
    setCurrentImageBlock();
    const idKey = pollName === 'first' ? 'firstLikieeId' : 'secondLikieeId';
    const imgKey = pollName === 'first' ? 'firstImage' : 'secondImage';
    setForm({ ...form, [idKey]: res.likieeId, [imgKey]: res.image });
  };

  if (currentImageBlock) {
    const currentImage = currentImageBlock === 'first' ? form.firstImage : form.secondImage;
    const currentLikiie = currentImageBlock === 'first' ? form.firstLikieeId : form.secondLikieeId;
    const existForm = currentImage && currentLikiie && { image: currentImage, likieeId: currentLikiie };
    return (
      <PollImageSelection
        existForm={existForm}
        onCancel={() => setCurrentImageBlock()}
        onChooseImages={onChooseImages.bind(null, currentImageBlock)}
      />
    );
  }

  return (
    <ManageModal
      title={t('poll_modal_title_new')}
      sumbitButton={t('btn_create')}
      onCloseModal={handleProjectModalClose}
      onSubmit={onFormSubmit}
      isButtonDisabled={fetching || !form.firstImage || !form.secondImage}
    >
      <div className='col-12 p-0'>
        <Input
          type='text'
          name='title'
          onChange={onFormChange}
          value={form.title}
          label={t('ph_title')}
          placeholder=''
          className='mb-12 mb-md-10'
          required
        />
        <Textarea
          name='description'
          onChange={onFormChange}
          value={form.description}
          label={t('ph_description')}
          placeholder=''
          className='mb-12 mb-md-10 textarea-sm'
        />
        <div className='mb-10 form-block pb-5'>
          <label className='fw-700 mb-6'>{t('ph_poll_images')}*</label>
          <div className='d-flex'>
            <PollImageBlock
              onClick={() => onSelectImageBlock('first')}
              image={form.firstImage}
              className={`col p-0 ${form.firstImage ? '' : 'mr-7'}`}
              imgClassName='is-first'
              title={t('text_poll_image_1')}
              onRemoveImage={() => setForm({ ...form, firstImage: '' })}
            />
            <PollImageBlock
              onClick={() => onSelectImageBlock('second')}
              image={form.secondImage}
              className={`col p-0 ${form.secondImage ? '' : 'ml-7'}`}
              imgClassName='is-second'
              title={t('text_poll_image_2')}
              onRemoveImage={() => setForm({ ...form, secondImage: '' })}
            />
          </div>
        </div>
      </div>
    </ManageModal>
  );
};

export default CreatePollModal;
